// removed by extract-text-webpack-plugin
module.exports = {"IndexAchiever":"IA__IndexAchiever__336B_","IndexAchieverPercentage":"IA__IndexAchieverPercentage__2Qgd-","percentageInputContainer":"IA__percentageInputContainer__CcWkR","indexLabel":"IA__indexLabel__1vgpr","invalid":"IA__invalid__xtPEG","validationMessage":"IA__validationMessage__3PrvT","instructionMsg":"IA__instructionMsg__296XC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/IA/IA.css
// module id = 530
// module chunks = 0